// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/index.less
// module id = 1264
// module chunks = 0